import { Reveal } from "@/components/common/Reveal";

export const SectionHeading = ({ eyebrow, title, subtitle, align = "center", className = "" }) => (
  <Reveal className={`${align === "center" ? "text-center mx-auto" : "text-left"} max-w-2xl ${className}`}>
    {eyebrow && (
      <div className="mb-3">
        <span className="inline-block text-xs font-semibold uppercase tracking-[0.18em] text-[var(--cdt-accent)]">
          {eyebrow}
        </span>
      </div>
    )}
    <h2 className="font-display text-3xl md:text-4xl lg:text-[2.75rem] leading-[1.1] tracking-[-0.02em] text-[var(--cdt-text)]">
      {title}
    </h2>
    {subtitle && <p className="mt-4 text-[var(--cdt-muted)] leading-8 text-base md:text-lg">{subtitle}</p>}
  </Reveal>
);
